module.exports = __webpack_public_path__ + "static/CIW_Part2-7f4b6e185079a8a0374c2706d86a989b.pdf";